"use client";

/* eslint-disable react/display-name */
import React, { ComponentType, useEffect, useState, useCallback } from "react";
import debounce from "lodash/debounce";

// helpers
import useUnreadMessages from "@/hooks/useUnreadMessages";


let interval: number | null = null;

export function withPageTitleNotification<T extends object>(Component: ComponentType<T>) {
  return (props: T) => {
    const [originalPageTitle, setOriginalPageTitle] = useState<string | null>(null);

    const [unreadMessages, connection] = useUnreadMessages();

    const onMessage = useCallback(debounce((unreadMessagesCount: number) => {
      if (unreadMessagesCount && originalPageTitle) {
        interval && clearInterval(interval);

        interval = setInterval(() => {
          document.title = document.title === originalPageTitle ? `(${unreadMessagesCount}) New Messages!` : originalPageTitle as string;
        }, 3000) as unknown as number;
      } else if (interval) {
        clearInterval(interval);
        document.title = originalPageTitle || "Lo:live";
      }
    }, 300), [interval, originalPageTitle]);
  
    useEffect(() => {
      setOriginalPageTitle(document.title);
    }, []);

    useEffect(() => {
      if (unreadMessages) {
        onMessage(unreadMessages);
      }

      if (connection) {
        return () => {
          clearInterval(interval as number);
        }
      }
    }, [connection, unreadMessages])
  
    return <Component { ...props as T }/>;
  };
}

export default withPageTitleNotification;
